export enum SignatureOperation {
    UPLOAD = 'upload',
    DELETE = 'delete',
    DOWNLOAD = 'download'
}